import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import CheckboxGroup from '../../../../features/components/Form/CheckboxGroup'
import ErrorMessage from '../../../../components/Form/ErrorMessage'

import {
  getAudienceNetworkCheckboxOptions,
  getFeedsCheckboxOptions,
  getInStreamCheckboxOptions,
  getMessagesCheckboxOptions,
  getSearchCheckboxOptions,
  getStoriesAndReelsCheckboxOptions
} from '../../placements/helpers'

import { campaignSelector } from '../../../../modules/selectors/campaigns'

import { PLACEMENT_POSITIONS } from '../../../Multiplatform/LineItemForms/fields'

const PlacementsSectionContent = ({ formik }) => {
  const { t } = useTranslation()

  const { objective: campaignObjective } = useSelector(campaignSelector)

  const { setFieldValue, setValues, values, errors, touched } = formik

  const placementsError = errors[PLACEMENT_POSITIONS]
  const placementsTouched = touched[PLACEMENT_POSITIONS]

  const feedsOptions = useMemo(() => getFeedsCheckboxOptions(campaignObjective), [campaignObjective])

  const checkboxGroupProps = {
    values: values,
    itemPath: PLACEMENT_POSITIONS,
    setFieldValue: setFieldValue,
    setValues: setValues,
    isLarge: false,
    showSelectAllButton: false
  }

  return (
    <>
      <CheckboxGroup title={t('Feeds')} options={feedsOptions} {...checkboxGroupProps} />
      <CheckboxGroup
        title={t('Stories and reels')}
        options={getStoriesAndReelsCheckboxOptions(campaignObjective)}
        {...checkboxGroupProps}
      />
      <CheckboxGroup
        title={t('In-stream ads for videos and reels')}
        options={getInStreamCheckboxOptions(campaignObjective)}
        {...checkboxGroupProps}
      />
      <CheckboxGroup
        title={t('Search results')}
        options={getSearchCheckboxOptions(campaignObjective)}
        {...checkboxGroupProps}
      />
      <CheckboxGroup
        title={t('Messages')}
        options={getMessagesCheckboxOptions(campaignObjective)}
        {...checkboxGroupProps}
      />
      <CheckboxGroup
        title={t('Apps and sites')}
        options={getAudienceNetworkCheckboxOptions(campaignObjective)}
        {...checkboxGroupProps}
      />

      {placementsError && placementsTouched && <ErrorMessage error={placementsError} />}
    </>
  )
}

export default PlacementsSectionContent
